import { render, staticRenderFns } from "./PalettePicker.vue?vue&type=template&id=4c277d16&"
import script from "./PalettePicker.vue?vue&type=script&lang=js&"
export * from "./PalettePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports